module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return (_vm.itype == 'textarea') ? _c('textarea', {
    staticClass: "form-control",
    attrs: {
      "rows": _vm.iRow,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.val
    }
  }) : _c('input', {
    staticClass: "form-control",
    class: [_vm.setSize],
    attrs: {
      "type": _vm.type,
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.val
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-76d71268!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/css/form/input.vue
// module id = 327
// module chunks = 2